"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCollapse = useCollapse;
exports.useFade = useFade;
exports.useScale = useScale;
exports.useSlide = useSlide;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
require("core-js/modules/es.array.concat.js");
var _insertCss = require("../insertCss");
var _hashObject = require("../hashObject");
var _usePrefixCls = require("./usePrefixCls");
/**
 * Animation transition can be used in TransitionGroup
 * */

var defaultEnterTimeout = 300;
var defaultLeaveTimeout = 300;
var generateFadeCSS = function generateFadeCSS(transition, fromOpacity, visibleOpacity) {
  return "\n.".concat(transition.classNames, "-enter {\n    opacity: ").concat(fromOpacity, " !important;\n}\n.").concat(transition.classNames, "-enter-active {\n    opacity: ").concat(visibleOpacity, " !important;\n    transition: opacity ").concat(transition.timeout.enter, "ms ease;\n}\n.").concat(transition.classNames, "-exit {\n    opacity: ").concat(visibleOpacity, " !important;\n}\n.").concat(transition.classNames, "-exit-active {\n    opacity: ").concat(fromOpacity, " !important;\n    transition: opacity ").concat(transition.timeout.exit, "ms ease;\n}\n");
};
var generateSlideCSS = function generateSlideCSS(transition, enterPosition, leavePosition) {
  var _enterPosition = (0, _slicedToArray2.default)(enterPosition, 2),
    translateX = _enterPosition[0],
    translateY = _enterPosition[1];
  if (typeof enterPosition[0] === 'number') {
    translateX = "".concat(enterPosition[0], "px");
  }
  if (typeof enterPosition[1] === 'number') {
    translateY = "".concat(enterPosition[1], "px");
  }
  var _leavePosition = (0, _slicedToArray2.default)(leavePosition, 2),
    leaveTranslateX = _leavePosition[0],
    leaveTranslateY = _leavePosition[1];
  if (typeof leavePosition[0] === 'number') {
    leaveTranslateX = "".concat(leavePosition[0], "px");
  }
  if (typeof leavePosition[1] === 'number') {
    leaveTranslateY = "".concat(leavePosition[1], "px");
  }
  return "\n  .".concat(transition.classNames, "-enter {\n      opacity: 0 !important;\n      transform: translate3d(").concat(translateX, ", ").concat(translateY, ", 0);\n  }\n  .").concat(transition.classNames, "-enter-active {\n      opacity: 1 !important;\n      transform: translate3d(0, 0, 0);\n      transition: opacity ").concat(transition.timeout.enter, "ms ease,\n                  transform ").concat(transition.timeout.enter, "ms ease;\n  }\n  .").concat(transition.classNames, "-exit {\n      opacity: 1 !important;\n      transform: translate3d(0, 0, 0);\n  }\n  .").concat(transition.classNames, "-exit-active {\n      opacity: 0 !important;\n      transform: translate3d(").concat(leaveTranslateX, ", ").concat(leaveTranslateY, ", 0);\n      transition: opacity ").concat(transition.timeout.exit, "ms ease,\n                  transform ").concat(transition.timeout.exit, "ms ease;\n  }\n  ");
};
var generateCollapseCSS = function generateCollapseCSS(transition, targetMaxHeight) {
  return "\n.".concat(transition.classNames, "-enter {\n    max-height: 0;\n    overflow: hidden;\n}\n.").concat(transition.classNames, "-enter-active {\n    max-height: ").concat(targetMaxHeight, "px;\n    transition: max-height ").concat(transition.timeout.enter, "ms ease;\n    overflow: hidden;\n}\n.").concat(transition.classNames, "-exit {\n    max-height: ").concat(targetMaxHeight, "px;\n    overflow: hidden;\n}\n.").concat(transition.classNames, "-exit-active {\n    max-height: 0;\n    transition: max-height ").concat(transition.timeout.exit, "ms ease;\n    overflow: hidden;\n}\n");
};
var generateScaleCSS = function generateScaleCSS(transition, enterScale, exitScale, origin) {
  return "\n.".concat(transition.classNames, "-enter {\n    opacity: 0 !important;\n    transform: scale3d(").concat(enterScale, ", ").concat(enterScale, ", ").concat(enterScale, ");\n    transform-origin: ").concat(origin, ";\n}\n.").concat(transition.classNames, "-enter-active {\n    opacity: 1 !important;\n    transform: scale3d(1, 1, 1);\n    transition: opacity ").concat(transition.timeout.enter, "ms ease,\n                transform ").concat(transition.timeout.enter, "ms ease;\n    transform-origin: ").concat(origin, ";\n}\n.").concat(transition.classNames, "-exit {\n    opacity: 1 !important;\n    transform: scale3d(1, 1, 1);\n    transform-origin: ").concat(origin, ";\n}\n.").concat(transition.classNames, "-exit-active {\n    opacity: 0 !important;\n    transform: scale3d(").concat(exitScale, ", ").concat(exitScale, ", ").concat(exitScale, ");\n    transition: opacity ").concat(transition.timeout.exit, "ms ease,\n                transform ").concat(transition.timeout.exit, "ms ease;\n    transform-origin: ").concat(origin, ";\n}\n");
};
var setupTransitions = {};

/**
 * generate a fade transition, enjoy it with TransitionGroup
 * */
function useFade() {
  var fromOpacity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var visibleOpacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var enterTimeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultEnterTimeout;
  var leaveTimeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultLeaveTimeout;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('transition');
  var name = "".concat(prefixCls, "-fade");
  var hash = (0, _hashObject.hashObject)({
    name: name,
    fromOpacity: fromOpacity,
    visibleOpacity: visibleOpacity,
    enterTimeout: enterTimeout,
    leaveTimeout: leaveTimeout
  });
  if (!setupTransitions[hash]) {
    setupTransitions[hash] = {
      classNames: name + hash,
      timeout: {
        enter: enterTimeout,
        exit: leaveTimeout + 0.0001
      },
      unmountOnExit: true,
      mountOnEnter: true
    };
    var transition = setupTransitions[hash];
    var css = generateFadeCSS(transition, fromOpacity, visibleOpacity);
    (0, _insertCss.insertCSS)(name + hash, css);
  }
  return setupTransitions[hash];
}

/**
 * generate a slide transition, enjoy it with TransitionGroup
 * */
function useSlide() {
  var enterPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0, -30];
  var leavePosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : enterPosition;
  var enterTimeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultEnterTimeout;
  var leaveTimeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultLeaveTimeout;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('transition');
  var name = "".concat(prefixCls, "-slide");
  var hash = (0, _hashObject.hashObject)({
    name: name,
    enterPosition: enterPosition,
    leavePosition: leavePosition,
    enterTimeout: enterTimeout,
    leaveTimeout: leaveTimeout
  });
  if (!setupTransitions[hash]) {
    setupTransitions[hash] = {
      classNames: name + hash,
      timeout: {
        enter: enterTimeout,
        exit: leaveTimeout
      },
      unmountOnExit: true,
      mountOnEnter: true
    };
    var transition = setupTransitions[hash];
    var css = generateSlideCSS(transition, enterPosition, leavePosition);
    (0, _insertCss.insertCSS)(name + hash, css);
  }
  return setupTransitions[hash];
}

/**
 * generate a slide transition, enjoy it with TransitionGroup
 * */
function useCollapse(targetHeight) {
  var enterTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEnterTimeout;
  var leaveTimeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultLeaveTimeout;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('transition');
  var name = "".concat(prefixCls, "-collapse");
  var hash = (0, _hashObject.hashObject)({
    name: name,
    targetHeight: targetHeight,
    enterTimeout: enterTimeout,
    leaveTimeout: leaveTimeout
  });
  if (!setupTransitions[hash]) {
    setupTransitions[hash] = {
      classNames: name + hash,
      timeout: {
        enter: enterTimeout,
        exit: leaveTimeout
      },
      unmountOnExit: true,
      mountOnEnter: true
    };
    var transition = setupTransitions[hash];
    var css = generateCollapseCSS(transition, targetHeight);
    (0, _insertCss.insertCSS)(name + hash, css);
  }
  return setupTransitions[hash];
}

/**
 * generate a scale transition, enjoy it with TransitionGroup
 * */
function useScale() {
  var enterScale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
  var exitScale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : enterScale;
  var enterTimeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultEnterTimeout;
  var leaveTimeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultLeaveTimeout;
  var origin = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'center';
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('transition');
  var name = "".concat(prefixCls, "-scale");
  var hash = (0, _hashObject.hashObject)({
    name: name,
    enterScale: enterScale,
    exitScale: exitScale,
    enterTimeout: enterTimeout,
    leaveTimeout: leaveTimeout,
    origin: origin
  });
  if (!setupTransitions[hash]) {
    setupTransitions[hash] = {
      classNames: name + hash,
      timeout: {
        enter: enterTimeout,
        exit: leaveTimeout
      },
      unmountOnExit: true,
      mountOnEnter: true
    };
    var transition = setupTransitions[hash];
    var css = generateScaleCSS(transition, enterScale, exitScale, origin);
    (0, _insertCss.insertCSS)(name + hash, css);
  }
  return setupTransitions[hash];
}